<div class="map-title">{{title}}</div>

<div class="text-center">
  <img class="main-chart img-fluid" src="{{image}}">
</div>
